import { TFunction } from 'i18next';
import { DateTime } from 'luxon';
import { ROI } from '../FundList/fundListOptions';
import { QuotesChangeRange } from './chartsModel';

const values = [
  { roiKey: ROI.M1, months: 1 },
  { roiKey: ROI.M3, months: 3 },
  { roiKey: ROI.M6, months: 6 },
  { roiKey: ROI.M12, months: 12 },
  { roiKey: ROI.M36, months: 36 },
  { roiKey: ROI.M60, months: 60 },
];


export const makeChangeRanges = (t: TFunction, date = DateTime.local()): QuotesChangeRange[] => {
  const ranges = values.map(({ roiKey, months }) => ({
    key: `${months}${t('month-one-letter')}`,
    fromDate: date.minus({months}).toISODate(),
    roiKey,
  }));

  return [
      ...ranges,
      { key: t('year-to-date-short'), fromDate: date.startOf('year').toISODate(), roiKey: ROI.YTD },
  ];
};
